import React from 'react';

const WarnIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <path
      d="M15.9997 7.99984C16.736 7.99984 17.333 8.59679 17.333 9.33317V18.6665C17.333 19.4029 16.736 19.9998 15.9997 19.9998C15.2633 19.9998 14.6663 19.4029 14.6663 18.6665V9.33317C14.6663 8.59679 15.2633 7.99984 15.9997 7.99984Z"
      fill="#F0384A"
    />
    <path
      d="M15.9997 24.6665C16.9201 24.6665 17.6663 23.9203 17.6663 22.9998C17.6663 22.0794 16.9201 21.3332 15.9997 21.3332C15.0792 21.3332 14.333 22.0794 14.333 22.9998C14.333 23.9203 15.0792 24.6665 15.9997 24.6665Z"
      fill="#F0384A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.137 6.37112C11.2126 4.10833 13.4943 2.6665 15.9997 2.6665C18.5051 2.6665 20.7868 4.10833 21.8623 6.37112L29.1532 21.7103C30.8352 25.2493 28.2546 29.3332 24.3362 29.3332H7.66308C3.74473 29.3332 1.16409 25.2493 2.84617 21.7103L10.137 6.37112ZM15.9997 5.33317C14.5235 5.33317 13.1792 6.18268 12.5455 7.51588L5.25463 22.8551C4.41358 24.6245 5.7039 26.6665 7.66308 26.6665H24.3362C26.2954 26.6665 27.5857 24.6245 26.7447 22.8551L19.4538 7.51588C18.8202 6.18268 17.4758 5.33317 15.9997 5.33317Z"
      fill="#F0384A"
    />
  </svg>
);

export default WarnIcon;
